export default class AlertsService {
  static $inject = ['$http'];

  baseUrl = '/aptitude/ApplicationAlertsServiceController/getApplicationAlerts';

  constructor(private $http) {
    'ngInject';
  }

  getAlerts(): ng.IPromise<any> {
    return this.$http.get(this.baseUrl, {
      intercept: true,
      cache: true
    });
  }
}
